import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import Box from 'shared/components/Box'
import { ThemeContext } from 'styled-components'
import { CheckinRowItem } from 'pages/CheckIn/model/checkin'
import usePageTable from 'shared/hooks/usePageTable'
import { NoteTypeWithStatus } from 'shared/components/Notes/models/note'
import Pagination from 'shared/components/DataTable/Pagination'
import flowRight from 'lodash/flowRight'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import NoteList from 'shared/components/Notes/components/NoteList'
import BackLink from 'shared/components/BackLink'
import { useSelector } from 'react-redux'
import upperCase from 'lodash/upperCase'
import { PARTICIPANT_ROLE_TEXT } from 'shared/hocs/withAuth'
import { sidebarSelector } from 'shared/components/Layout/Sidebar'

type ViewAllNotesProps = {
  participant: CheckinRowItem
}

type Props = WrappedProps<ViewAllNotesProps> & {
  participant: CheckinRowItem
}
function ViewAllNotes(props: Props) {
  const { participant, onContinue } = props
  const theme = useContext(ThemeContext)
  const { sidebar_roles } = useSelector(sidebarSelector)
  const participantLabel = useMemo(() => {
    let label = 'Participants'
    if (sidebar_roles) {
      let participantRole = sidebar_roles.find(r => upperCase(r.name) === PARTICIPANT_ROLE_TEXT)
      if (participantRole) {
        label = participantRole.display_name || participantRole.name
      }
    }
    return label
  }, [sidebar_roles])

  const [pageTableState, pageTableHandlers] = usePageTable<NoteTypeWithStatus>({
    isPaginated: true,
    isBaseQuery: false,
    queryNode: 'note',
    searchableFields: ['message'],
    queryParams: {
      user_id: participant.id,
      filter_id: 'All Notes',
    },
    initialSort: [{ column: 'created_date', direction: 'desc' }],
  })
  const { tableState, rowResponse } = pageTableState
  return (
    <ViewAllNotesContainer>
      <BackLink onClick={onContinue} color={theme.colors.main} label={`Back to ${participantLabel} Check-In`} mb="40px" />
      <div className="note-card-container">
        <NoteList notes={rowResponse.data.data} user_id={participant.id} />
      </div>

      <Pagination
        pageSizes={[10, 20, 40, 60, 80]}
        size={tableState.size}
        page={tableState.page}
        count={rowResponse.data.count || 0}
        setSize={(payload: number) => pageTableHandlers.tableDispatch({ type: 'SetSize', payload })}
        setPage={(payload: number) => pageTableHandlers.tableDispatch({ type: 'SetPage', payload })}
      />
    </ViewAllNotesContainer>
  )
}

const ViewAllNotesContainer = styled(Box)`
  overflow: auto;
  margin: 60px 15px 0 40px;
  padding-right: 15px;
  max-height: calc(100vh - 150px);
`

const ViewAllNotesDialog = flowRight(withDialog())(ViewAllNotes)

ViewAllNotesDialog.defaultProps = {
  dialogClassName: 'dialog--large',
  hasCancel: false,
  footerClassName: 'dialog__footer--less-padding',
}

export default ViewAllNotesDialog
